// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__2VjA_","backdrop":"style_backdrop__2qQEK","dialog":"style_dialog__3Flah","row":"style_row__icy_I","edit":"style_edit__1BviW","header":"style_header__1IeDW"};